module.exports = __webpack_public_path__ + "static/img/21c.760c8b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/21c.jpg
// module id = nZNg
// module chunks = 0